module.exports = __webpack_public_path__ + "01f43047/img/pwrd-by-sourcery-black.bba9ba41.svg";